import React from 'react'
import ContactForm from './ContactForm'
import ContactAddress from './ContactAddress'

const ContactUs = () => {
  return (
    <div className='contact-us'>
      <ContactAddress />
      
    </div>
  )
}

export default ContactUs
